import React from 'react';
import Icon from '../../../components/AppIcon';

const QualityMetricsDashboard = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Pass Rate',
      value: `${metrics?.passRate}%`,
      change: metrics?.passRateChange,
      icon: 'CheckCircle2',
      color: 'var(--color-success)'
    },
    {
      label: 'Avg Inspection Time',
      value: `${metrics?.avgInspectionTime}m`,
      change: metrics?.inspectionTimeChange,
      icon: 'Clock',
      color: 'var(--color-primary)'
    },
    {
      label: 'Defects Found',
      value: metrics?.defectsFound,
      change: metrics?.defectsChange,
      icon: 'AlertTriangle',
      color: 'var(--color-warning)'
    },
    {
      label: 'Compliance Score',
      value: `${metrics?.complianceScore}%`,
      change: metrics?.complianceChange,
      icon: 'Shield',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="p-4 md:p-6 rounded-xl border border-border bg-card hover:shadow-lg transition-all duration-250"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl"
                 style={{ backgroundColor: `${metric?.color}20` }}>
              <Icon name={metric?.icon} size={20} color={metric?.color} />
            </div>
            <div className={`flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
              metric?.change >= 0 ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
            }`}>
              <Icon name={metric?.change >= 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
              <span>{Math.abs(metric?.change)}%</span>
            </div>
          </div>
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground mb-1 data-text">
            {metric?.value}
          </h3>
          <p className="caption text-muted-foreground">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QualityMetricsDashboard;